import type { GetUsersQuery, GetUsersResponse } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

async function getUsers(query: GetUsersQuery): Promise<GetUsersResponse> {
  return requestApiJsonOrThrow<GetUsersResponse>('admin/users', {
    params: query,
  })
}

export const usersQuery = (queryParams: GetUsersQuery) => ({
  queryKey: ['users', queryParams],
  queryFn: () => getUsers(queryParams),
})
